/* eslint-disable no-invalid-this */
export const debounce = (fn, time) => {
  let timeout = null;

  return function () {
    // eslint-disable-next-line prefer-rest-params
    const functionCall = () => fn.apply(this, arguments);

    clearTimeout(timeout);
    timeout = setTimeout(functionCall, time);
  };
};
